<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Carrinho",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader },
  data() {
    return {
      updating: true,
      title: "Carrinho",
      items: [
        {
          text: "Comercial",
          href: "/",
        },
        {
          text: "Carrinho",
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.totalRows = this.items.length;
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th>Produto</th>
                  <th>Descrição</th>
                  <th>Valor</th>
                  <th>Quantidade</th>
                  <th colspan="2">Total</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <img
                        src="@/assets/images/product/img-1.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                    />
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <router-link
                          to="/ecommerce/product-detail"
                          class="text-dark"
                      >Produto Testes 0002</router-link
                      >
                    </h5>
                    <p class="mb-0">
                      Color :
                      <span class="fw-medium">Maroon</span>
                    </p>
                  </td>
                  <td>R$ 450,00</td>
                  <td>
                    <input
                        type="number"
                        value="2"
                        name="demo_vertical"
                        class="form-control"
                        style="width: 120px"
                    />
                  </td>
                  <td>R$ 900,00</td>
                  <td>
                    <a
                        href="javascript:void(0);"
                        class="action-icon text-danger"
                    >
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <img
                        src="@/assets/images/product/img-2.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                    />
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <router-link
                          to="/ecommerce/product-detail"
                          class="text-dark"
                      >Produto Testes 0099</router-link
                      >
                    </h5>
                    <p class="mb-0">
                      Color :
                      <span class="fw-medium">Light blue</span>
                    </p>
                  </td>
                  <td>R$ 225,00</td>
                  <td>
                    <input
                        type="number"
                        value="1"
                        name="demo_vertical"
                        class="form-control"
                        style="width: 120px"
                    />
                  </td>

                  <td>R$ 225,00</td>
                  <td>
                    <a
                        href="javascript:void(0);"
                        class="action-icon text-danger"
                    >
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <img
                        src="@/assets/images/product/img-3.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                    />
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <router-link
                          to="/ecommerce/product-detail"
                          class="text-dark"
                      >Produto Testes 0088</router-link
                      >
                    </h5>
                    <p class="mb-0">
                      Color :
                      <span class="fw-medium">Black</span>
                    </p>
                  </td>
                  <td>R$ 152,00</td>
                  <td>
                    <input
                        type="number"
                        value="2"
                        name="demo_vertical"
                        class="form-control"
                        style="width: 120px"
                    />
                  </td>

                  <td>R$ 304,00</td>
                  <td>
                    <a
                        href="javascript:void(0);"
                        class="action-icon text-danger"
                    >
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <img
                        src="@/assets/images/product/img-4.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                    />
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <router-link
                          to="/ecommerce/product-detail"
                          class="text-dark"
                      >Produto Testes 0001</router-link
                      >
                    </h5>
                    <p class="mb-0">
                      Color :
                      <span class="fw-medium">Blue</span>
                    </p>
                  </td>
                  <td>R$ 145,00</td>
                  <td>
                    <input
                        type="number"
                        value="2"
                        name="demo_vertical"
                        class="form-control"
                        style="width: 120px"
                    />
                  </td>

                  <td>R$ 290,00</td>
                  <td>
                    <a
                        href="javascript:void(0);"
                        class="action-icon text-danger"
                    >
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>


                </tbody>
              </table>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="$router.go(-1)"
                    class="btn btn-secondary"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar
                </button>
              </div>
              <!-- end col -->
              <div class="col-sm-6">
                <div class="text-sm-end mt-2 mt-sm-0">
                  <router-link to="/loja/pagamento" class="btn btn-success">
                    <i class="mdi mdi-cart-arrow-right me-1"></i> Confirmar Pedido
                  </router-link>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row-->
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-4">Cartão</h5>

            <div class="card bg-primary text-white visa-card mb-0">
              <div class="card-body">
                <div>
                  <i class="bx bxl-visa visa-pattern"></i>

                  <div class="float-end">
                    <i class="bx bxl-visa visa-logo display-3"></i>
                  </div>

                  <div>
                    <i class="bx bx-chip h1 text-warning"></i>
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-4">
                    <p>
                      <i class="fas fa-star-of-life m-1"></i>
                      <i class="fas fa-star-of-life m-1"></i>
                      <i class="fas fa-star-of-life m-1"></i>
                    </p>
                  </div>
                  <div class="col-4">
                    <p>
                      <i class="fas fa-star-of-life m-1"></i>
                      <i class="fas fa-star-of-life m-1"></i>
                      <i class="fas fa-star-of-life m-1"></i>
                    </p>
                  </div>
                  <div class="col-4">
                    <p>
                      <i class="fas fa-star-of-life m-1"></i>
                      <i class="fas fa-star-of-life m-1"></i>
                      <i class="fas fa-star-of-life m-1"></i>
                    </p>
                  </div>
                </div>

                <div class="mt-5">
                  <h5 class="text-white float-end mb-0">12/25</h5>
                  <h5 class="text-white mb-0">João da Silva</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Resumo de Pedido</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                <tr>
                  <td>Valor Total Bruto</td>
                  <td class="float-end">R$ 1.857,00</td>
                </tr>
                <tr>
                  <td>Desconto</td>
                  <td class="float-end">- R$ 157,00</td>
                </tr>
                <tr>
                  <td>Frete</td>
                  <td class="float-end">R$ 26,00</td>
                </tr>
                <tr>
                  <th>Valor Total</th>
                  <th class="float-end">R$ 1.744,22</th>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
